import React, { FC } from "react";
import { Grid, Typography } from "@mui/material";
import { ScreenProps } from "../index";

const WelcomeSection: FC<ScreenProps> = ({ message }) => {
  return (
    <>
      {!message && (
        <Grid container justifyContent={"center"} sx={{ paddingY: "70px" }}>
          <Grid item xs={8}>
            <Typography
              variant={"h1"}
              fontWeight={900}
              color={"#ffffff"}
              letterSpacing={"1px"}
              fontSize={30}
              lineHeight={"1.3em"}
              sx={{ paddingY: "30px" }}
            >
              Welcome
            </Typography>
            <Typography
              variant={"body2"}
              fontWeight={600}
              color={"#ffffff"}
              letterSpacing={"1px"}
              sx={{ marginTop: 2 }}
            >
              Thank you for your interest in registering for the 16<sup>th</sup>{" "}
              ICA-AP Regional Assembly and related events. We are looking
              forward to seeing you in Manila, Philippines from 6 to 10 November
              2023.
            </Typography>
            <Typography
              variant={"body2"}
              fontWeight={600}
              color={"#ffffff"}
              letterSpacing={"1px"}
              sx={{ marginTop: 2 }}
            >
              Please ensure that you have read the{" "}
              <a
                href={
                  "https://regionalassembly.coop/RA2023/general-information.php"
                }
              >
                General Information, Terms & Conditions
              </a>{" "}
              carefully. Your registration will not be complete unless you have
              paid your registration fee.
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default WelcomeSection;
